import _$ from "1dr-utils/helpers/docReady";
import qsa from "1dr-utils/helpers/elsForEach";

export default function onClick(selector, callback) {
  _$(() => {
    if (!selector) {
      return;
    }

    if (typeof callback != "function") {
      console.warn("callback was not a function");
      return false;
    }

    var _bind = function (el, cb) {
      var fn = cb.bind(el);
      el.addEventListener("click", (e) => {
        fn(e);
      });
    };

    if (selector instanceof HTMLElement) {
      _bind(selector, callback);
    } else {
      qsa(selector, (el) => {
        _bind(el, callback);
      });
    }
  });
}
